const STORAGE_KEY = "mst:selectedVersionByBranch";
const LEGACY_STORAGE_KEY = "mst:selectedVersion";

type StoredMap = Record<string, number>;

function readMap(): StoredMap {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? (parsed as StoredMap) : {};
  } catch {
    return {};
  }
}

export function readVersionIdForBranch(branchUid: string): number | undefined {
  const value = readMap()[branchUid];
  return typeof value === "number" ? value : undefined;
}

export function writeVersionIdForBranch(branchUid: string, versionId: number) {
  try {
    const map = readMap();
    map[branchUid] = versionId;
    localStorage.setItem(STORAGE_KEY, JSON.stringify(map));
  } catch {
    // localStorage 접근 실패는 무시 (시크릿 모드/쿼터 초과 등)
  }
}

export function clearLegacySelectedVersion() {
  try {
    localStorage.removeItem(LEGACY_STORAGE_KEY);
  } catch {
    // ignore
  }
}
